<template>
  <div class="succes-page">
    <img class="success-qrcode" src="@/assets/img/actouch/qrcode.jpg"/>
  </div>
</template>
<script>
import sasdk from './sasdkinit'
export default {
  mounted () {
    sasdk.viewsuccess()
  }
}
</script>
<style lang="scss" scoped>
  .succes-page{
    background: url('~@/assets/img/actouch/success.png') no-repeat;
    width:750px;
    background-size:746px 1378px;
    background-position: center top;
    min-height:1378px;
    height:100vh;
    margin:0 auto;
    position: relative;
    background-color:#2079FF;
  }
  .success-qrcode{
    width:470px;
    height:470px;
    position: absolute;
    top:695px;
    left:140px;
  }
</style>
